import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import AcademicPage from '../../views/AcademicPage/';
import $ from 'jquery';

const GLOBAL = require('../../Globals');
const tabletd ={
	
	border : '1px solid black',borderCollapse : 'collapse'
};

class Summary extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			depart: [],
			acyear : '',
			data : [],
			department : '',
			employee : '',
		}
		this.onDepChange = this.onDepChange.bind(this);
		this.onEmpChange = this.onEmpChange.bind(this);
		this.printDocument = this.printDocument.bind(this);
	}
	
	printDocument() {
		
		var content = document.getElementById("show");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}
	
	onDepChange(e){
		
		this.state.department = e.target.value;
		this.state.depname = $("#dep").find(':selected').attr('data-dep');
	}
	
	onEmpChange(e){
		
		this.state.employee = e.target.value;
		this.state.empname = $("#emp").find(':selected').attr('data-empname');
		this.getdata();
	}
	
	componentDidMount() {
		 
		this.getdepartment();
		this.getacyear();
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					depart : responseJson
				});
			}
		});
	}
	
	getdata(){
		
		GetData('timetable/getsummary/'+this.state.employee).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
  render() {
	
	var dep = this.state.depart;
	
	/** get Employee By Department **/
	$("#dep").change(function(){
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'employee/getempbydept/'+fr,function(o){
			$("#emp").html('');
			$('#emp')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Employee- '));
			$('#emp')
				.append($("<option></option>")
				.attr("value",'all')
				.text('All')); 
			$.each(o,function(key,value){
				   $('#emp')
					.append($("<option></option>")
					.attr("value",value.id)
					.attr("data-empname",value.empname)
					.text(value.empname)); 	
										
			});	
			
		},'json');
	
	});
	
	if(this.state.department!='' && this.state.employee!=''){
		
		$("#show").show();
	}
	else{
		
		$("#show").hide();
	}
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
					<Card>
					  <CardHeader>
						<strong>Staff Summary</strong>
					  </CardHeader>
					  <CardBody>
						<Row>
						  <Col md="1" className="staff">
							<FormGroup>
								<Label>Department</Label>
							</FormGroup>
						  </Col>
						  <Col md="2" className="staff">
							<FormGroup>
								<select name="dept" onChange={this.onDepChange} id="dep" className="form-control" required> 
								<option value="">Select Department</option>
								<option value="all">All</option>
								{
									dep.map(function (item) {
										return <option value={item.id} data-dep={item.department}>{item.department}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						   <Col md="1" className="staff">
							<FormGroup>
								<Label>Employee</Label>
							</FormGroup>
						  </Col>
						  <Col md="2" className="staff">
							<FormGroup>
								<select name="employee" onChange={this.onEmpChange} id="emp" className="form-control" required> 
								
								</select>
							</FormGroup>
						  </Col>
						  <Col md="6" className="class">
							<FormGroup>
								<Button style={{float : 'right'}} size="sm" color="warning" onClick={this.printDocument}>Print</Button>
							</FormGroup>
						  </Col>
						  <Col md="12" id="show">
							<Table responsive style={tabletd} width="100%">
							  <thead>
								<tr>
									<th style={tabletd}>S.No</th>
									<th style={tabletd}>Employee Name</th>
									<th style={tabletd}>Department</th>
									<th style={tabletd}>No. of Period</th>
								</tr>
							  </thead>
							  <tbody>
								{this.state.data.map((item,i) =>
									<tr key={i}>
										<td style={tabletd}>{i+1}</td>
										<td style={{textTransform : 'uppercase',border : '1px solid black',borderCollapse : 'collapse'}}>{item.empname}</td>
										<td style={tabletd}>{item.depname}</td>
										<td style={tabletd} align="center">{item.pcount}</td>
									</tr>
								)}
							  </tbody>
							</Table>
						  </Col>
						  <iframe name="print_frame" id="print_frame" width="0" height="0" frameBorder="0" src="about:blank"></iframe>
						</Row>	
					  </CardBody>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Summary;


// WEBPACK FOOTER //
// ./src/timetable/Summary/Summary.js